import { createSlice } from '@reduxjs/toolkit';
import { initialState } from '../../../../data/setup/priceBook/initialState.priceClass.data';
import {
  priceClassSearchData as priceClassSearchAPI,
  fetchPriceClassData as fetchPriceClassDataAPI,
} from '../../../../apis/priceBookAPI';
import { ACTION_PRICE_CLASS } from '../../../../constants/actionCreator';
import { handleRejection } from '../../../../constants';
import { createAsyncThunkWrapper } from '../../../../services/common/asyncThunkWrapper';

// API Call Functions
export const searchPriceClassData = createAsyncThunkWrapper(
  ACTION_PRICE_CLASS.SEARCH_PRICE_CLASS,
  priceClassSearchAPI
);

export const fetchPriceClassData = createAsyncThunkWrapper(
  ACTION_PRICE_CLASS.FETCH_PRICE_CLASS_DATA,
  fetchPriceClassDataAPI
);

const priceClassSlice = createSlice({
  name: 'priceClass',
  initialState,
  reducers: {
    setSelectedValue: (state, action) => {
      state.selectedData[action.payload.name] = action.payload.value;
    },
    setIsExpanded: (state, action) => {
      state.isExpanded = action.payload;
    },
    resetValues: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(searchPriceClassData.pending, (state) => {
        state.loading = true;
        state.isPriceClassSearchedDataFound = false;
        state.isPriceClassDataSearched = true;
        state.searchResultData = [];
        state.isSearchedPriceClassesResults = null;
      })
      .addCase(searchPriceClassData.fulfilled, (state, action) => {
        state.loading = false;
        state.searchResultData = action.payload[0]?action.payload[0].priceClasses:[];
        state.priceClasseCount = action.payload[0]?.totalCount? action.payload[0].totalCount : 0;
        state.isPriceClassSearchedDataFound = true;
        state.isSearchedPriceClassesResults =
        action.payload[0]?.priceClasses?.length === 0;
      })
      .addCase(searchPriceClassData.rejected, (state, action) => {
        handleRejection(state, action);
        state.searchResultData = [];
        state.priceClasseCount = 0;
        state.isSearchedPriceClassesResults = true;

      })

      .addCase(fetchPriceClassData.pending, (state) => {
        state.priceClassData = [];
        state.loading = true;
        state.isPriceClassDataFound = false;
        state.isPriceClassResults = null;
      })
      .addCase(fetchPriceClassData.fulfilled, (state, action) => {
        state.loading = false;
        state.priceClassData = action.payload?action.payload.priceClasses : [];
        state.priceClasseCount = action.payload?.totalCount? action.payload.totalCount : 0;
        state.isPriceClassDataFound = true;
        state.isPriceClassResults = action.payload?.priceClasses?.length === 0;
      })
      .addCase(fetchPriceClassData.rejected, (state) => {
        state.loading = false;
        state.isPriceClassDataFound = true;
        state.isPriceClassResults = true;
        state.priceClasseCount = 0;
        state.priceClassData = [];

      });
  },
});

export const { setSelectedValue, resetValues, setIsExpanded } =
  priceClassSlice.actions;
export default priceClassSlice.reducer;
